import React from "react";
import { Link } from "react-router-dom";

export default function ProfitNotFoundPage() {
  return (
    <div className="profit-card profit-empty-state">
      <div className="profit-page-title">Page not found</div>
      <div className="profit-page-subtitle">
        This partner page has not been mapped yet. Head back to the dashboard.
      </div>
      <Link className="profit-button profit-button-primary" to="/profit/dashboard">
        Back to dashboard
      </Link>
    </div>
  );
}
